import React from "react";
import { Clear } from "@material-ui/icons";
import { ThemeType } from "@theme";
import { SelectorValueInputProps } from "./utils";
import { makeStyles, useTheme } from "@material-ui/styles";
import IconButton from "@material-ui/core/IconButton";

type Props = SelectorValueInputProps;

export const SlimVirtualSelectorValue = ({
  clearable,
  onClear,
  value,
  onClick
}: Props) => {
  const theme = useTheme();
  const { clear, root } = useStyles(theme);
  const hasValue = value.length > 0;

  return (
    <div onClick={onClick} className={root}>
      <div style={{ flex: 1 }}>
        {hasValue ? value.map((v) => v.label).join(", ") : <div>&nbsp;</div>}
      </div>

      {clearable && hasValue && (
        <div className={clear}>
          <IconButton size={"small"}>
            <Clear
              onClick={(e) => {
                e.stopPropagation();
                onClear(e);
              }}
              fontSize="inherit"
            />
          </IconButton>
        </div>
      )}
    </div>
  );
};

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    display: "flex",
    padding: `${theme.spacing(1)}px`,
    width: "100%",
    alignItems: "center"
  },
  clear: {
    display: "flex",
    fontSize: 16,

    "& > svg": {
      opacity: 0.65,
      transition: theme.transitions.create("opacity", { duration: 100 })
    },

    "& > svg:hover": {
      opacity: 0.9,
      cursor: "pointer"
    }
  }
}));
